import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {
  //Get and save user device info in deviceInfo Observable
  private deviceInfo = new BehaviorSubject<{}>({});
  public deviceInfo$: Observable<{}> = this.deviceInfo.asObservable();
  private isScaled = new BehaviorSubject<boolean>(false);
  public isScaled$: Observable<boolean> = this.isScaled.asObservable();
  constructor() { }

  setDeviceInfo(value: {}) {
    this.deviceInfo.next(value);
  }

  setScaled(scaled: boolean) {
    this.isScaled.next(scaled);
  }
}